import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage";
import BecomePartner from "../pages/BecomePartner";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import SearchTalent from "../pages/SearchTalent";
import TermsCondition from "../pages/TermsAndConditions";
import Aboutus from "../pages/AboutUs";
import JoinUs from "../pages/JoinUs";

// Company related pages
import CompanyRegister from "../pages/Company/Register";
import SelectCompany from "../pages/Company/Register";
import CompanyLogin from "../pages/Company/Login";
import UploadDocuments from "../pages/Company/UploadDocuments";
import CompanyVerifyOTP from "../pages/Company/VerifyOTP";
import CompanyDashboardLayout from '../pages/Company/DashboardLayout';
import CompanyDashboard from "../pages/Company/Dashboard";
import CompanyProfile from "../pages/Company/Profile";
import CompanyTalents from "../pages/Company/Talents";
import CompanyQuotes from "../pages/Company/Qutations";
import CompanyTransactions from "../pages/Company/Transactions";
import CompanyHistory from "../pages/Company/History";
import HireTheTalent from "../pages/Company/HireTheTalent";
import CompanyQuoteDetails from "../pages/Company/QuoteDetails";
import CompanySettings from "../pages/Company/Settings";
import CompanyForgotPassword from "../pages/Company/ForgotPassword";



// Talent related pages
import TalentVerifyOTP from "../pages/Talent/VerifyOTP";
import TalentRegister from "../pages/Talent/Register";
import TalentLogin from "../pages/Talent/Login";
import TalentDashboardLayout from '../pages/Talent/DashboardLayout';
import TalentDashboard from "../pages/Talent/Dashboard";
import TalentProfile from "../pages/Talent/Profile";
import TalentSettings from "../pages/Talent/Settings";
import TalentProjects from "../pages/Talent/Projects";
import TalentEarnings from "../pages/Talent/Earnings";
import TalentHistory from "../pages/Talent/History";
import TalentForgotPassword from "../pages/Talent/ForgotPassword";
import DynamicPage from "../pages/DynamicPage";
import TalentView from "../pages/Company/TalentView";
import CompanyNotification from "../pages/Company/CompanyNotification";
import TalentNotification from "../pages/Talent/TalentNotification";
import ProjectDetails from "../pages/Talent/ProjectDetails";

const AppRouter = () => {
  const basePath = process.env.REACT_APP_BASE_PATH;

  return (
    <Router basename={basePath}>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/talents" element={<SearchTalent />} />
        <Route path="/become-partner" element={<BecomePartner />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsCondition />} />
        <Route path="/about-us" element={<Aboutus />} />
        <Route path="/join-us" element={<JoinUs />} />
        <Route path="/:slug" element={<DynamicPage />} />


        {/* Company Routes Group */}
        <Route path="/company">
          <Route index element={<SelectCompany />} />
          <Route path="register" element={<CompanyRegister />} />
          <Route path="login" element={<CompanyLogin />} />
          <Route path="verify-otp" element={<CompanyVerifyOTP />} />
          <Route path="upload-documents" element={<UploadDocuments />} />
          <Route path="forgot-password" element={<CompanyForgotPassword />} />

          
          {/* Authenticated Company Routes */}
          <Route  element={<CompanyDashboardLayout />}>
              <Route path="dashboard" element={<CompanyDashboard />} />
              <Route path="profile" element={<CompanyProfile />} />
              <Route path="talents" element={<CompanyTalents />} />
              <Route path="talents" element={<CompanyTalents />} />
              <Route path="hire-talent" element={<HireTheTalent />} />
              <Route path="history" element={<CompanyHistory />} />
              <Route path="quotes" element={<CompanyQuotes />} />
              <Route path="transactions" element={<CompanyTransactions />} />
              <Route path="quote-details" element={<CompanyQuoteDetails />} />
              <Route path="settings" element={<CompanySettings />} />
              <Route path="talent-profile" element={<TalentView />} />
          <Route path="notification" element={<CompanyNotification/>} />


          </Route>
        </Route>
        {/* Talent Routes Group */}
        <Route path="/talent">
          <Route path="register" element={<TalentRegister />} />
          <Route path="login" element={<TalentLogin />} />
          <Route path="verify-otp" element={<TalentVerifyOTP />} />
         <Route path="forgot-password" element={<TalentForgotPassword />} />

            <Route element={<TalentDashboardLayout />}>
              <Route path="dashboard" element={<TalentDashboard />} />
              <Route path="profile" element={<TalentProfile />} />
              <Route path="settings" element={<TalentSettings />} />
              <Route path="projects" element={<TalentProjects />} />
              <Route path="earnings" element={<TalentEarnings />} />
              <Route path="history" element={<TalentHistory />} />
          <Route path="notification" element={<TalentNotification/>} />
          <Route path="project-details" element={<ProjectDetails/>} />
            </Route>

        </Route>

      </Routes>
    </Router>
  );
};

export default AppRouter;